import React from "react";
import "./styles.css";
import NumberFormat from "react-number-format";
import { Images } from "../../theme";

export default function InputTextCustom({
  headingLabel,
  placeholder,
  disabled,
  value,
  onChange,
  type,
  max,
  min,
  id,
  step,
  errorState,
  inputRef,
  name,
  className,
  labelClass,
}) {
  return (
    <>
      <label
        for={id}
        className={labelClass ? labelClass : "control-label customStyleLabel"}
      >
        {headingLabel}
      </label>
      <NumberFormat
        type="text"
        ref={inputRef}
        id={id}
        step={step}
        className={className ? className : "form-control customStyleInput"}
        min={min}
        max={max}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        name={name}
        format="#### #### ####"

      />
      {errorState && (
        <div style={{ color: "red", fontSize: 12 }}>{errorState}</div>
      )}
    </>
  );
}
